module.exports = __webpack_public_path__ + "media/images/soar/favicon-e821aba53d64f14d6ebf8c1f0e2620dc.png";